var Handlebars = require("/root/project/webapp/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<span class=\"project-state-label\"\n      style=\"background-color: "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.state : depth0)) != null ? stack1.color : stack1), depth0))
    + "; margin-right: 8px;\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.state : depth0)) != null ? stack1.name : stack1), depth0))
    + "</span>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./balus/ui/template/body/project/cover/state.hbs
// module id = 956
// module chunks = 0